// extracted by mini-css-extract-plugin
module.exports = {"segment":"segment-1da5j","airplane__name":"airplane__name-3cCgY","sunInfo":"sunInfo-1QK8m"};